import { BASE_IMAGE_URL } from '@/helpers/apiUtilities.js';
import { parseISO } from 'date-fns';

const helpers = {
  getFullName: function (user) {
    let fullName = '';
    if (user?.firstName) {
      fullName += user.firstName + ' ';
    }
    if (user?.lastName) {
      fullName += user.lastName;
    }
    return fullName;
  },
  getInitials: function (user) {
    const firstInitial = user?.firstName?.[0]?.toUpperCase();
    const lastInitial = user?.lastName?.[0]?.toUpperCase();
    let initials = '';
    if (firstInitial) {
      initials += firstInitial;
    }
    if (lastInitial) {
      initials += lastInitial;
    }

    return initials;
  },
  formatDate: function (date, { dash, withTime, format, hourCycle } = {}) {
    withTime = withTime === undefined ? true : withTime;
    format = format === undefined ? 'YYYYMMDD' : format;
    hourCycle = hourCycle === undefined ? 'h23' : hourCycle;

    if (typeof date === 'string') {
      date = parseISO(date);
      if (isNaN(date.getTime())) {
        return '';
      }
    }

    const year = date.getFullYear();
    const day = date.toLocaleString('default', { day: '2-digit' });
    const month = date.toLocaleString('default', { month: 'numeric' });
    let time;
    if (hourCycle === 'h12') {
      time = date.toLocaleTimeString('default', { hour: 'numeric', minute: '2-digit' });
    } else if (hourCycle === 'h23') {
      time = date.toLocaleTimeString('default', { hour12: false, hour: 'numeric', minute: '2-digit' });
    }
    const [hour, minute] = time.split(':');
    if (hour === '24') {
      time = '00:' + minute;
    }
    const seperator = dash ? '-' : '/';

    if (format === 'YYYYMMDD') {
      return withTime
        ? `${year}${seperator}${month}${seperator}${day} ${time}`
        : `${year}${seperator}${month}${seperator}${day}`;
    } else if (format === 'MMDDYYYY') {
      return withTime
        ? `${month}${seperator}${day}${seperator}${year} ${time}`
        : `${month}${seperator}${day}${seperator}${year}`;
    }
    return '';
  },
  getAvatarUrl: function (user) {
    if (user?.imageURL) {
      return BASE_IMAGE_URL + '/' + user.imageURL;
    }
  },
  capitalizeFirstLetter: function (string) {
    return string[0].toUpperCase() + string.slice(1);
  },
  lowercaseFirstLetter: function (string) {
    return string[0].toLowerCase() + string.slice(1);
  }
};

export default helpers;
